import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { BooksFormValues } from 'src/models/Books.model';

type Props = {
    formikProps: FormikProps<BooksFormValues>;
    onClose: () => void;
    formType: "ADD" | "EDIT";
};

const BookForm = ({ formikProps, onClose, formType }: Props) => {
    const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

    return (
        <div className='p-4 flex flex-col gap-6'>
            <div className='flex justify-between items-center'>
                <div className='text-xl font-medium'>
                    <div className='text-xl font-medium'>
                        {formType === "ADD" ? "Add Book" : "Update Book"}{" "}
                    </div>
                </div>
                <button type='button' className='hover:bg-hover' onClick={onClose}>
                    Cancel
                </button>
            </div>
            <div className='flex flex-col gap-4'>
                <div>
                    <ATMTextField
                        name='bookName'
                        required
                        value={values.bookName}
                        onChange={(e) => {
                            setFieldValue('bookName', e.target.value);
                        }}
                        label='Book Name'
                        onBlur={handleBlur}
                    />
                </div>
            </div>
            <div>
                <ATMLoadingButton isLoading={isSubmitting} type='submit'>
                    Save
                </ATMLoadingButton>
            </div>
        </div>
    );
};

export default BookForm;